/**
 * Customer Portal (UI) - dashboard variant router.
 *
 * This maps dashboard variant contracts to concrete variant components.
 */
import type { DashboardResponse } from '../../types/portal';
import { DirectB2BDashboard } from './direct-b2b-dashboard';
import { ReferralPartnerDashboard } from './referral-partner-dashboard';
import { ResellerDashboard } from './reseller-dashboard';

type DashboardRouterProps = {
  dashboard: DashboardResponse;
};

export function DashboardRouter({ dashboard }: DashboardRouterProps) {
  if (dashboard.dashboardVariant === 'direct_overview') {
    return <DirectB2BDashboard dashboard={dashboard} />;
  }
  if (dashboard.dashboardVariant === 'partner_overview') {
    return <ReferralPartnerDashboard dashboard={dashboard} />;
  }
  return <ResellerDashboard dashboard={dashboard} />;
}
